import RedantAvatarIcon from "@src/app/assets/icons/redant-avatar.svg?react";
import TimerIcon from "@src/app/assets/icons/time.svg?react";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import dayjs from "dayjs";
import { Fragment, type ReactElement } from "react";

import Link from "../Link";

export default function ArticleAuthorBar(): ReactElement {
  const { article } = useRouteResponse("articlePage");
  const {
    created = "",
    updated = "",
    display_update_time = false,
  } = article || {};

  const formattedPublishDate = created
    ? dayjs(created).format("YYYY年MM月DD日 HH:mm")
    : "";

  const formattedUpdateDate =
    display_update_time && updated
      ? dayjs(updated).format("YYYY年MM月DD日 HH:mm")
      : "";

  const authors = article?.authors;

  console.log("author", authors);

  return (
    <div
      className="flex flex-col gap-x-[12px] gap-y-[8px] lg:flex-row"
      data-testid={`article-authorbar-${article?.id}`}
    >
      {/* author */}
      {authors && authors.length > 0 && (
        <div className="flex flex-wrap gap-x-[8px] gap-y-[4px]">
          <RedantAvatarIcon width="24px" height="24px" />

          {/* authors link */}
          {authors.map((author, index) => (
            <Fragment key={author.urlPath}>
              <Link
                to={author.urlPath || ""}
                className="text-subheader text-primary"
              >
                {author.name}
              </Link>
              {authors.length > 1 && index !== authors.length - 1 ? (
                <span>/</span>
              ) : (
                ``
              )}
            </Fragment>
          ))}
        </div>
      )}

      <div className="flex shrink-0 flex-wrap gap-x-[12px] gap-y-[8px] text-subheader text-secondary ">
        {/* publish date */}
        {formattedPublishDate ? (
          <div className="flex items-center gap-[8px]">
            <TimerIcon width="16px" height="16px" />
            <span>发布:</span>
            <span>{formattedPublishDate}</span>
          </div>
        ) : null}

        {/* update date */}
        {formattedUpdateDate ? (
          <div className="flex items-center gap-[8px]">
            <span>更新:</span>
            <span>{formattedUpdateDate}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
